/* eslint-disable react/prop-types */
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import '../alert-form.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectActionsData } from '../../../../redux/slices/alertFormSlice/alertFormSlice';
import ActionSummaryRow from '../../common/actions/ActionSummaryRow';
import { selectUserList } from '../../../../redux/slices/userListSlice/userListSlice';

function DefineActionsSummary({ onEdit = null }) {
  const { actions } = useSelector(selectActionsData);
  const users = useSelector(selectUserList);
  return (
    <Card className="alert-card">
      <Card.Body>
        <Row className="align-items-center">
          <Col>
            <Card.Title className="mb-0">Actions:</Card.Title>
          </Col>
          <Col className="text-right">
            {/* eslint-disable-next-line react/button-has-type */}
            {
              onEdit && (
              <FontAwesomeIcon
                className="btn btn-link"
                onClick={onEdit}
                icon={faPencil}
              >
                Edit
              </FontAwesomeIcon>
              )
            }
          </Col>
        </Row>
        {actions.length === 0 && (
        <>
          None
        </>
        )}
        {actions && actions.length > 0 && actions.map((action, index) => (
          <React.Fragment key={index}>
            <ActionSummaryRow action={action} usersList={users} />
            <hr />
          </React.Fragment>
        ))}
      </Card.Body>
    </Card>
  );
}

DefineActionsSummary.defaultProps = {
  onEdit: null,
};
DefineActionsSummary.propTypes = {
  onEdit: PropTypes.func,
};
export default DefineActionsSummary;
